/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoilePercentage } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_002: Question = {
  id: 'multi-002-aires-conservation-public',
  oldId: '63',
  title: 'Aires de conservation aménagées pour le public',
  number: '5.2',
  description: ['Proportion des aire de conservation/milieux naturels accessibles à la population qui sont aménagées, dans les limites des capacités de support de l\'écosystème'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 41) return 3;
        if (data >= 26) return 2;
        if (data >= 11) return 1;
        return 0;
      },
      score: '0',
      labels: ['0% - 10%', '11% - 25%', '26% - 40 %', '+ de 40 %'],
      maxScore: 3,
      help: etoilePercentage,
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

const question_multi_002__v3: Question = {
  ...question_multi_002,
  frequency: 2,
  number: '5.1',
};

export const question_multi_002_v2: Question = question_multi_002;
export const question_multi_002_v3: Question = question_multi_002__v3;
